import { gateway } from "../../../../gateway";
import { ICreateInvoicePayload } from "../interfaces/invoice.interfaces";

export const createInvoiceAction = async (
  invoice: ICreateInvoicePayload,
  companyId: number
): Promise<any> => {
  const response = await gateway.post(
    "/invoices",
    { ...invoice },
    {
      headers: {
        companyid: companyId.toString(), // Backend expects lowercase 'companyid'
      },
    }
  );
  return response.data;
};  